<template>
  <div id="app">
    <div style="color:#ec706f;background-color: #fff4f6;padding:10px;text-align:center; font-size:14px;" v-if="isIE">
      <b>提示：</b>您正在使用IE浏览器，为了更好的浏览体验，强烈建议您更换为其他浏览器！
      (<a href="https://www.google.cn/chrome/" target="_blank">谷歌浏览器</a>)
      (<a href="http://www.firefox.com.cn/" target="_blank">火狐浏览器</a>)
    </div>
    <template>

      <section class="top-gg-section" v-if="shouldShowTopAd">
        <div class="gg-banner" style="height:80px;width:100%;">
          <swiper :options="swiperOptionTop">
            <swiper-slide :class="{'cur-poi': item.link}" v-for="item in homeData.topAd || []" v-lazy:backgroundImage="item.path"
                          :key="item.path" @click.native="$router.open(item.link)"></swiper-slide>
            <div class="swiper-pagination swiper-pagination-top" slot="pagination" v-show="homeData.topAd && homeData.topAd.length > 1"></div>
          </swiper>
        </div>
        <a href="javascript:" class="close el-icon-close" title="关闭" @click="bindCloseTopAd"></a>
      </section>

      <tx-top-bar v-if="showTopBar"/>
      <router-view class="child-view" v-if="$route.name"/>
      <div class="child-view" v-else v-loading.fullscreen="true"></div>
      <tx-footer :is-sample="$route.name === 'PaperView'"/>
      <vue-progress-bar/>
      <!--<div style="height: 100px;" v-if="isShowVIP !== -1">
        <tx-footer-vip></tx-footer-vip>
      </div>-->
      <tx-get-vip-dialog/>
      <tx-login-dialog/>
      <!--评分弹框-->
      <tx-grade-pop v-if="isShowGradePop"/>
      <!--纠错弹框-->
      <tx-correct-pop v-if="isShowCorrectPop"/>
      <!--收藏弹框-->
      <tx-collect-pop v-if="isShowCollectPop"/>
      <!--word设置弹框-->
      <tx-paper-down-pop v-if="isShowPaperDownPop"/>
      <!--侧边帮助栏-->
      <tx-quick-aside @showFeedback="() => {$refs.feedbackDialog.open()}"></tx-quick-aside>
      <!--试题篮-->
      <tx-basket-aside v-if="isShowBasketAside"></tx-basket-aside>
      <!--试题篮试题列表-->
      <tx-basket-question-list v-if="isShowBasketAside" @click.native.stop></tx-basket-question-list>
    </template>
    <feedback-dialog ref="feedbackDialog"/>
  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
  import $ from 'jquery'
  import _ from 'lodash'
  import { isLogin } from './utils/auth'
  import FeedbackDialog from './components/dialog/feedback-dialog'

  export default {
    name: 'App',
    components: {
      FeedbackDialog
    },
    data () {
      return {
        swiperOptionTop: {
          pagination: {
            el: '.swiper-pagination-top',
            clickable: true
          },
          effect: 'fade',
          autoplay: {
            delay: 4000
          },
          loop: false
        },
        topAdVisible: true,
        isIE: navigator.userAgent.indexOf('Trident') > -1 || navigator.userAgent.indexOf('Edge') > -1,
        showFooterVip: ['VIP'],
        showGradePop: ['Search', 'DailyPaper', 'PaperDetail', 'ZJZJ', 'KDZJ'],
        showCorrectPop: ['Search', 'DailyPaper', 'PaperDetail', 'ZJZJ', 'KDZJ'],
        showCollectPop: ['Search', 'DailyPaper', 'PaperDetail', 'ZJZJ', 'KDZJ', 'PaperView'],
        showPaperDownPop: ['Search', 'MXMJ', 'PaperDetail', 'PaperView'],
        showBasketAside: ['PaperDetail', 'Search', 'ZJZJ', 'KDZJ', 'DailyPaper', 'UserQues']
      }
    },
    computed: {
      ...mapState('common', ['loginDialogVisible', 'homeData']),
      ...mapGetters('common', ['currentSubject', 'subjectList']),
      // shouldReturnTruthy
      shouldShowTopAd () {
        let topAd = this.homeData.topAd
        return this.topAdVisible && topAd && topAd.length
      },
      currentRoute () {
        return this.$route.name
      },
      showTopBar () {
        return !['Login', 'Register', 'OauthBindAccount'].includes(this.$route.name)
      },
      isShowVIP () {
        return this.showFooterVip.includes(this.currentRoute)
      },
      isShowGradePop () {
        return this.showGradePop.includes(this.currentRoute)
      },
      isShowCorrectPop () {
        return this.showCorrectPop.includes(this.currentRoute)
      },
      isShowCollectPop () {
        return this.showCollectPop.includes(this.currentRoute)
      },
      isShowPaperDownPop () {
        return this.showPaperDownPop.includes(this.currentRoute)
      },
      isShowBasketAside () {
        return this.showBasketAside.includes(this.currentRoute)
      }
    },
    created () {
      let vm = this
      // 免费送vip
      // if (new Date() < new Date('2020-06-09')) {
      //   if (!isLogin()) {
      //     if (checkShouldReturnTruthy('show_home_dialog_ad', 2)) {
      //       vm.setGetVipDialogVisible(true)
      //     }
      //   }
      // }
      vm.getSubjectList()
      if (isLogin()) {
        vm.updateIsLogin(1)
        vm.getUserInfo().then(() => {
          vm.getSubjectPaperConfig()
          vm.updatePaperCfg()
          vm.getCatalogList()
        })
      }
    },
    mounted () {
      /**
       * 更新设备宽度, resize变化时，防止频繁执行回调函数
       */
      let $win = $(window)
      this.updateDeviceWidth($(window).width())
      $win.resize(_.debounce(() => {
          this.updateDeviceWidth($(window).width())
        }, 100, {
          leading: true, // 延时开始前调用
          trailing: true
        }
      ))
      let $doc = $(document)
      $doc.on('scroll', () => {
        this.updateScrollTop($doc.scrollTop())
      })
      $doc.on('scroll', _.debounce(() => {
        let scrollHeight = $doc.get(0).scrollHeight - $doc.scrollTop() - $win.height()
        this.updateScrollBottom(scrollHeight)
      }, 100, {
        leading: true, // 延时开始前调用
        trailing: true
      }))
    },
    methods: {
      ...mapMutations('user', ['initUserInfo', 'updateIsLogin']),
      ...mapMutations('common', ['setGetVipDialogVisible']),
      ...mapMutations(['updateDeviceWidth', 'updateScrollBottom', 'updateScrollTop']),
      ...mapMutations('basket', ['updatePaperCfg']),
      ...mapActions('common', ['getSubjectList', 'getCatalogList']),
      ...mapActions('user', ['getUserInfo']),
      ...mapActions('basket', ['getSubjectPaperConfig']),
      bindCloseTopAd () {
        this.topAdVisible = false
      },
      bindAddCatalog () {}
    }
  }
</script>
<style lang="less">
  @import "./styles/_mixins-wln";
  #app {
    margin-left: auto;
    margin-right: auto;
    color: #333;
    background: #ffffff;
  }
  .top-gg-section {
    height:80px;
    min-width: @body-min-width;
    position: relative;
    .close {
      font-size:15px;
      z-index: 10;
      position: absolute;
      right:10px;
      top:50%;
      transform: translateY(-50%);
      color:#fff;
      border-radius: 50%;
      width:24px;
      height:24px;
      line-height: 25px;
      text-align: center;
      background-color: rgba(255,255,255,.25);
    }

    .gg-banner {
      height:80px;
      .swiper-slide {
        width: 100%;
        height: 80px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
      }

      .swiper-pagination {
        bottom: 2px;
        .swiper-pagination-bullet {
          width: 7px;
          height: 7px;
          background: #ffffff;
          opacity: 0.5;
          margin: 0 6px;

          &.swiper-pagination-bullet-active {
            opacity: 1;
          }
        }
      }
    }
  }

  .child-view {
    min-height: calc(100vh - 126px - 34px);
    margin: 0 auto;
  }

  .el-dialog__header {
    background: #FAFAFA;
    border: 1px solid #EEEEEE;
    padding: 10px 15px;
  }

  .el-dialog__header .el-dialog__title {
    font-size: 16px;
  }

  .el-dialog__headerbtn {
    top: 12px;
    right: 15px;
    font-size: 20px;
  }
</style>
